module.exports = __webpack_public_path__ + "static/media/2.9a081fc5.svg";